"use client";

import { useEffect, useRef, useState } from "react";

export function useScrollHidden(
	enabled = true,
	{
		threshold = 4,
		topPadding = 20,
	}: { threshold?: number; topPadding?: number } = {},
) {
	const [isHidden, setIsHidden] = useState(false);
	const lastScrollYRef = useRef(0);

	useEffect(() => {
		if (!enabled || typeof window === "undefined") {
			setIsHidden(false);
			return;
		}

		lastScrollYRef.current = window.scrollY;
		let ticking = false;

		const handleScroll = () => {
			const currentScrollY = window.scrollY;
			if (ticking) return;

			window.requestAnimationFrame(() => {
				const lastScrollY = lastScrollYRef.current;
				const delta = currentScrollY - lastScrollY;
				if (currentScrollY <= topPadding || delta < -threshold) {
					setIsHidden(false);
				} else if (delta > threshold && currentScrollY > topPadding) {
					setIsHidden(true);
				}
				lastScrollYRef.current = currentScrollY;
				ticking = false;
			});
			ticking = true;
		};

		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, [enabled, threshold, topPadding]);

	return isHidden;
}
